// @mui material components
import { Link } from "react-router-dom";

// Soft UI Dashboard PRO React components
import SoftTypography from "components/SoftTypography";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
function GoBackButton() {
  return (
    <Link to={-1}>
      <SoftTypography
        variant="h6"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
      >
        <ArrowBackIosIcon color="disabled" />
        Go Back to Users
      </SoftTypography>
    </Link>
  );
}

export default GoBackButton;
